import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CanvasState {
    targetComponent: string | null;
    repanTrigger: boolean; // NEW: To force re-trigger
}

const initialState: CanvasState = {
    targetComponent: null,
    repanTrigger: false // NEW
};

const canvasSlice = createSlice({
    name: "canvas",
    initialState,
    reducers: {
        setTargetComponent: (state, action: PayloadAction<string | null>) => {
            state.targetComponent = action.payload;
            state.repanTrigger = !state.repanTrigger; // Toggle repanTrigger to force effect to run
        }
    }
});

export const { setTargetComponent } = canvasSlice.actions;
export default canvasSlice.reducer;
